import React, { useState } from 'react';
import { Button, Popover, Box } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const MonthRangePicker = ({ onApply, disabled }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [tempDateRange, setTempDateRange] = useState([null, null]);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const open = Boolean(anchorEl);

    const applyRange = () => {
        if (tempDateRange[0] && tempDateRange[1]) {
            onApply([
                dayjs(tempDateRange[0]).format('YYYY-MM'),
                dayjs(tempDateRange[1]).format('YYYY-MM'),
            ]);
            handleClose();
        }
    };

    return (
        <>
            <Button
                variant="outlined"
                onClick={handleClick}
                disabled={disabled}
                sx={{
                    color: '#1c4546',
                    backgroundColor: 'white',
                    border: '1px solid #1c4546',
                    borderRadius: '8px',
                    fontSize: '16px',
                    width: '310px',
                    cursor: 'pointer',
                    textTransform: 'none', // optional: keeps original casing
                    '&:hover': {
                        backgroundColor: '#f2f2f2',
                    },
                    height: '57.5px'
                }}
            >
                Select Month Range
            </Button>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Box sx={{ p: 2, display: 'flex', gap: 2, flexDirection: 'column' }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            views={['year', 'month']}
                            label="Start Month"
                            value={tempDateRange[0]}
                            onChange={(newValue) => {
                                if (newValue && tempDateRange[1] && dayjs(newValue).isAfter(tempDateRange[1], 'month')) {
                                    alert("Start month cannot be after end month");
                                    return;
                                }
                                setTempDateRange([newValue, tempDateRange[1]]);
                            }}
                            disableFuture
                            format="YYYY-MM"
                        />
                        <DatePicker
                            views={['year', 'month']}
                            label="End Month"
                            value={tempDateRange[1]}
                            onChange={(newValue) => {
                                if (newValue && tempDateRange[0] && dayjs(newValue).isBefore(tempDateRange[0], 'month')) {
                                    alert("End month cannot be before start month");
                                    return;
                                }
                                setTempDateRange([tempDateRange[0], newValue]);
                            }}
                            disableFuture
                            format="YYYY-MM"
                        />
                    </LocalizationProvider>

                    <Button
                        variant="contained"
                        onClick={applyRange}
                        disabled={!tempDateRange[0] || !tempDateRange[1]}
                        sx={{
                            backgroundColor: '#1C4546',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1C4546',
                            },
                        }}
                    >
                        Apply
                    </Button>
                </Box>
            </Popover>
        </>
    );
};

export default MonthRangePicker;
